// Persist handles only, never source inputs or credentials. Every poll remains
// authenticated and server-authorized. sessionStorage is isolated to this tab.
const KEY = "spyglass-active-sizing-jobs-v1";
let scope = 'signed-out';
export function scopeSizingJobs(actor: string) { scope = `${location.host}:${actor}`; }
export function readSizingJobs(): Record<string, string> {
  try {
    const value = JSON.parse(sessionStorage.getItem(`${KEY}:${scope}`) || "{}");
    return Object.fromEntries(Object.entries(value).filter(([key, id]) => key && typeof id === "string")) as Record<string, string>;
  } catch { return {}; }
}
export function writeSizingJobs(jobs: Record<string, string>) {
  try { sessionStorage.setItem(`${KEY}:${scope}`, JSON.stringify(jobs)); } catch { /* storage can be unavailable */ }
}
